import Swal from 'sweetalert2';
import { companyUnity, selectChannel } from '../../modules/select';

import { lang, tr } from '../../utils/helpers';

export const profilesTerms = () => {
  companyUnity();
  selectChannel();
  validate();
};

const validate = () => {
  const $form = document.getElementById('form-terms');
  const $company = document.getElementById('company_id');
  const $unity = document.getElementById('unity_id');
  const $cpf = document.getElementById('cpf');
  const $phone = document.getElementById('mobile_phone');
  const $capture_channel = document.getElementById('capture_channel');

  const $terms = document.querySelectorAll('.js-check');

  $form.addEventListener('submit', e => {
    if (document.querySelectorAll('.js-check:checked').length !== $terms.length) {
      e.preventDefault();
      Swal.fire(tr[lang].modal_error_attentio, tr[lang].modal_error_terms, 'error');
    }

    if (!$company.value || !$unity.value || !$cpf.value || !$phone.value || !$capture_channel.value) {
      e.preventDefault();
      Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
    }

    if (lang === 'pt-BR') {
      if ($cpf.value.length < 14) {
        e.preventDefault();
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
      }
    } else {
      if ($cpf.value.length < 6) {
        e.preventDefault();
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
      }
    }
  });
};
